import React from 'react';
import { IconProps } from '../types/types';

const NZDUSD: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 40 43" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <circle cx={14.33} cy={14.33} r={13.83} stroke="#fff" />
        <mask
            id="nzdusd_svg__a"
            style={{
                maskType: 'alpha'
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={29}
            height={29}
        >
            <path d="M14.33 27.91c7.5 0 13.58-6.08 13.58-13.58S21.83.75 14.33.75.75 6.83.75 14.33s6.08 13.58 13.58 13.58Z" fill="#F0F0F0" stroke="#fff" strokeWidth={0.5} />
        </mask>
        <g mask="url(#nzdusd_svg__a)">
            <path d="M14-3v1.681L7.379 1.993H14v4.992H7.379L14 10.348V12.13H10.842l-9.32-4.687v4.687h-5.043V7.444l-9.321 4.687H-16V32h60V-3H14ZM1.521-3v4.585L10.64-3H1.52Z" fill="#1A237B" />
            <path
                d="M14-3 4.015 1.993h-2.24L11.757-3h-1.12L1.52 1.585V-3H.502v6.012h13.497v-1.02H7.378l6.621-3.31V-3ZM4.22 6.017H.502v6.114h1.019V7.444l9.32 4.687H14v-.102L4.016 6.985h2.241L14 10.908v-.56L7.378 6.985h6.621v-.968H4.221Z"
                fill="#fff"
            />
            <path d="M14-3h-2.242L1.775 1.993h2.241L14-3ZM4.018 6.985 14 12.03v-1.12L6.259 6.984H4.018Z" fill="#BD0034" />
            <path d="M-2.503-3V3.012H-16v3.005h13.497v6.114H.503V6.017H14V3.012H.503V-3h-3.006Z" fill="#BD0034" />
            <path d="M25.664 7.24h1.63l.51-1.58.509 1.58h1.63l-1.325.917.51 1.58-1.325-.968-1.324.968.51-1.58-1.325-.917Z" fill="#fff" />
            <path d="M26.377 7.444h1.07l.356-1.019.306 1.019h1.12l-.866.662.306 1.02-.866-.663-.866.662.306-1.019-.866-.662Z" fill="#BD0034" />
            <path d="M19.145 13.761h1.63l.509-1.528.51 1.528h1.629l-1.324.968.509 1.58-1.324-.968-1.325.968.51-1.58-1.325-.968Z" fill="#fff" />
            <path d="M19.857 14.016h1.07l.357-1.019.305 1.019h1.12l-.916.662.356 1.02-.865-.663-.866.662.305-1.019-.866-.662Z" fill="#BD0034" />
            <path d="M25.408 24.103h1.834l.56-1.732.56 1.732h1.834l-1.477 1.07.56 1.732-1.477-1.07-1.477 1.07.56-1.732-1.477-1.07Z" fill="#fff" />
            <path d="M26.225 24.358h1.222l.357-1.12.356 1.12h1.223l-.968.713.356 1.121-.967-.713-.968.713.356-1.12-.967-.714Z" fill="#BD0034" />
        </g>
        <circle cx={26.011} cy={28.542} r={13.275} fill="#fff" stroke="#fff" strokeWidth={0.5} />
        <path d="M26.01 41.567c7.192 0 13.024-5.832 13.024-13.025 0-7.193-5.831-13.025-13.025-13.025-7.193 0-13.025 5.832-13.025 13.025 0 7.193 5.832 13.025 13.025 13.025Z" fill="#F0F0F0" />
        <path
            d="M25.441 28.542h13.591c0-1.176-.156-2.314-.448-3.398H25.44v3.398ZM25.441 21.746h11.68a13.095 13.095 0 0 0-3.006-3.397h-8.674v3.397ZM26.008 41.567c3.065 0 5.883-1.06 8.108-2.832H17.9a12.969 12.969 0 0 0 8.108 2.832ZM14.897 35.337h22.226a12.948 12.948 0 0 0 1.463-3.398H13.434a12.948 12.948 0 0 0 1.463 3.398Z"
            fill="#D80027"
        />
        <path
            d="M19.018 17.551h1.187l-1.104.802.421 1.298-1.104-.802-1.104.802.365-1.121a13.096 13.096 0 0 0-2.527 2.815h.38l-.702.51c-.11.184-.215.37-.315.557l.335 1.033-.626-.455a12.9 12.9 0 0 0-.426 1.012l.37 1.138h1.365l-1.104.802.421 1.297-1.104-.802-.66.48c-.067.533-.102 1.075-.102 1.625H26.01V15.517c-2.573 0-4.971.747-6.991 2.034Zm.504 9.689-1.104-.803-1.104.802.422-1.297-1.104-.802h1.365l.421-1.298.422 1.298h1.365l-1.104.802.421 1.297Zm-.421-5.092.421 1.297-1.104-.802-1.104.802.422-1.297-1.104-.803h1.365l.421-1.297.422 1.297h1.365l-1.104.803Zm5.093 5.091-1.104-.802-1.104.802.422-1.297-1.104-.802h1.365l.421-1.298.422 1.298h1.364l-1.104.802.422 1.297Zm-.421-5.091.421 1.297-1.104-.802-1.104.802.422-1.297-1.104-.803h1.365l.421-1.297.422 1.297h1.364l-1.104.803Zm0-3.795.421 1.298-1.104-.802-1.104.802.422-1.298-1.104-.802h1.365l.421-1.298.422 1.298h1.364l-1.104.802Z"
            fill="#0052B4"
        />
    </svg>
);

export default NZDUSD;
